import { Component, computed } from '@angular/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { AppInfo } from '../../../../global/environment';

@Component({
  selector: 'app-mmr-page-error',
  imports: [ButtonComponent],
  templateUrl: './mmr-page-error.component.html',
  styleUrl: './mmr-page-error.component.scss',
})
export class MmrPageErrorComponent {
  private viewModel = computed(() => {
    return {
      dashboardLink: `${AppInfo.Environment.myAccountURL}/my-plans`,
    };
  });

  get vm() {
    return this.viewModel();
  }
}
